import React,{useEffect, useState} from 'react';
import '../css/MobileNotes.css';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Card, CardContent, Typography, Accordion, AccordionSummary, AccordionDetails, Stack } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import '../css/MobileNotes.css';
import {APIGetNotes} from '../APIS/wupuapAPI.js'
import parse from 'html-react-parser';

const MobileNotes = (props) => {
    const [notes,setNotes]= useState([])
    const auth = useSelector(state => state.auth)

    const summaryFields = ['CompanyName', 'FullName'];
    useEffect(()=> {
        async function LoadData() {
            const ret = await APIGetNotes({
            token: auth.token,
            ttp_lead_id: props.data.uid,
            })
            if(ret.status)
            setNotes(ret.data)
        }

        if(auth.token > "" && typeof props.data !== 'undefined' && props.data.id > "" )
            LoadData();
    },[props.data, auth.token]);



  return (
    <Box>
      <Stack spacing={2}>
        {notes.map((row) => (
          <Card key={row.note_id} variant="outlined">
            <CardContent>
                  <div key={`summary_${row.note_id}`} className='notesummarysection'>
                    <span className='note_title'>Title: {row.title}</span>
                    <span className='note_date' >Date: {new Date(row.datetime_added).toLocaleString()}</span>
                    <span className='note_addedby' >Added By: {row.added_by}</span>
                    <span className='note_summary' >Summary: {`${(row.note??"").substring(0,50)}`}...</span>
                  </div>
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  View Notes
                </AccordionSummary>
                <AccordionDetails>
                <div className='note_text' dangerouslySetInnerHTML={{ __html: row.note.replaceAll("\n","<br/>") }} />
                </AccordionDetails>
              </Accordion>
            </CardContent>
          </Card>
        ))}
      </Stack>
    </Box>
  );
};

export default MobileNotes;
